"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _searchField = _interopRequireDefault(require("@amzn/meridian-tokens/component/search-field"));

var _find = _interopRequireDefault(require("lodash/find"));

var _focus = _interopRequireDefault(require("../_focus"));

var _focusTrap = _interopRequireDefault(require("../_focus-trap"));

var _theme = require("../theme");

var _popoverController = _interopRequireDefault(require("../_popover-controller"));

var _optionList = _interopRequireWildcard(require("../_option-list"));

var _highlightSubstring = _interopRequireDefault(require("../highlight-substring"));

var _focusRing = _interopRequireDefault(require("./../_styles/focus-ring"));

var _text = _interopRequireDefault(require("./../_styles/text"));

var _token = require("./../_utils/token");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var styles = function styles(t, _ref) {
  var width = _ref.anchorRect.width,
      focus = _ref.focus;
  return (0, _emotion.css)((0, _focusRing["default"])(t.tokens, {
    focus: focus,
    offset: 1,
    borderRadius: t("borderRadius"),
    borderWidth: t("borderWidth")
  }), {
    zIndex: t("popoverElevation"),
    background: t("backgroundColor"),
    border: t.borderCss("border"),
    borderRadius: t("borderRadius"),
    // HACK: we set overflow to hidden to make sure the
    // suggestions' boxy corners don't bleed outside the
    // popover's nice rounded corners. But we only do when
    // the popover is not in focus because when it IS in
    // focus we want to see that nice focus ring which appears
    // on the outside edge of the popover
    overflow: !focus ? "hidden" : undefined,
    outline: "none",
    width: width
  });
};

var optionListWrapperStyles = function optionListWrapperStyles(_ref2) {
  var maxHeight = _ref2.maxHeight;
  return (0, _emotion.css)({
    maxHeight: maxHeight,
    overflowX: "hidden",
    overflowY: "auto"
  });
};

var headerStyles = function headerStyles(t) {
  return (0, _emotion.css)((0, _text["default"])(t), (0, _defineProperty2["default"])({
    padding: "".concat(t("headerSpacingVertical"), "px ").concat(t("headerSpacingHorizontal"), "px"),
    borderBottom: t.borderCss("headerBorder"),
    borderColor: t("headerBorderColor"),
    fontSize: t("headerFontSize"),
    lineHeight: t("headerLineHeight"),
    // HACK: IE11 does not support text-align "end" or "start" so we have
    // to use directional left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    //   textAlign: "end"
    textAlign: "right"
  }, "[dir=\"rtl\"] &", {
    textAlign: "left"
  }));
};

var footerStyles = function footerStyles(t) {
  return (0, _emotion.css)({
    borderTop: t.borderCss("footerBorder"),
    borderColor: t("footerBorderColor"),
    padding: "".concat(t("footerSpacingVertical"), "px ").concat(t("footerSpacingHorizontal"), "px")
  });
};

var SearchSuggestionPopover = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SearchSuggestionPopover, _React$Component);

  var _super = _createSuper(SearchSuggestionPopover);

  function SearchSuggestionPopover() {
    var _this;

    (0, _classCallCheck2["default"])(this, SearchSuggestionPopover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      selectedValue: undefined,
      defaultPreselectedIndex: undefined
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFocusOptionList", function () {
      return _this.setState({
        defaultPreselectedIndex: undefined
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlurOptionList", function () {
      return _this.setState({
        defaultPreselectedIndex: -1
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClickSuggestion", function (suggestion) {
      return function () {
        _this.setState({
          selectedValue: suggestion.value
        });

        suggestion.onClick(suggestion.label);

        _this.props.onClickSuggestion();
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseDownNonOptionChildren", function (event) {
      event.preventDefault();
    });
    return _this;
  }

  (0, _createClass2["default"])(SearchSuggestionPopover, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          suggestions = _this$props.suggestions,
          query = _this$props.query; // If the query has been updated and it does not exists in suggestions,
      // clear the selected Value

      if (prevProps.query !== query && !(0, _find["default"])(suggestions, function (suggestion) {
        return suggestion.label === query;
      })) {
        this.setState({
          selectedValue: undefined
        });
      }
    }
    /**
     * Disable mouse interaction with any non-option children because a) it would
     * blur the select and cause it to close and b) we really don't want anyone
     * including interactive elements here because they'll be inaccessible to
     * keyboard users.
     *
     * NOTE: a `pointerEvents: none` style on the non-option children container is
     * not enough to prevent a blur event on the option list, we have to actually
     * prevent the event's default behavior.
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var state = this.state;
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _searchField["default"],
        map: (0, _token.getTokenHelper)("searchFieldSuggestionList")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement(_popoverController["default"], {
          open: props.open,
          anchorNode: props.anchorNode,
          anchorOrigin: "bottom center",
          popoverOrigin: "top center",
          offsetVertical: t("popoverOffsetVertical")
        }, function (_ref3) {
          var popoverStyle = _ref3.popoverStyle,
              anchorRect = _ref3.anchorRect;
          return /*#__PURE__*/_react["default"].createElement(_focus["default"], {
            onFocus: _this2.onFocusOptionList,
            onBlur: _this2.onBlurOptionList,
            multipleTargets: true
          }, function (_ref4) {
            var focusProps = _ref4.focusProps,
                focus = _ref4.focus,
                focusTrigger = _ref4.focusTrigger;
            return /*#__PURE__*/_react["default"].createElement(_focusTrap["default"], {
              onBeforeBlur: props.onBeforeBlur
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: "\n                        ".concat(styles(t, {
                anchorRect: anchorRect,
                focus: focus && focusTrigger === "keyboard"
              }), "\n                        ").concat(popoverStyle)
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: headerStyles(t),
              onMouseDown: _this2.onMouseDownNonOptionChildren
            }, props.header), props.suggestions.length ? /*#__PURE__*/_react["default"].createElement("div", {
              className: optionListWrapperStyles(props)
            }, /*#__PURE__*/_react["default"].createElement(_optionList["default"], (0, _extends2["default"])({}, focusProps, {
              id: props.popoverId,
              ref: props.optionListRef,
              defaultPreselectedIndex: state.defaultPreselectedIndex,
              onChangePreselectedIndex: props.onChangePreselectedIndex
            }), props.suggestions.map(function (suggestion) {
              return /*#__PURE__*/_react["default"].createElement(_optionList.OptionListItem, {
                key: suggestion.value,
                label: suggestion.label,
                onClick: _this2.onClickSuggestion(suggestion),
                disabled: suggestion.disabled,
                selected: suggestion.value === state.selectedValue
              }, function (_ref5) {
                var preselected = _ref5.preselected;
                return suggestion.render ? suggestion.render({
                  query: props.query,
                  highlighted: preselected || suggestion.value === state.selectedValue
                }) : /*#__PURE__*/_react["default"].createElement(_highlightSubstring["default"], {
                  match: props.query
                }, suggestion.label);
              });
            }))) : props.message.length ? /*#__PURE__*/_react["default"].createElement("div", {
              onMouseDown: _this2.onMouseDownNonOptionChildren
            }, props.message) : null, props.footer && /*#__PURE__*/_react["default"].createElement("div", {
              className: footerStyles(t)
            }, props.footer)));
          });
        });
      });
    }
  }]);
  return SearchSuggestionPopover;
}(_react["default"].Component);

SearchSuggestionPopover.propTypes = process.env.NODE_ENV !== "production" ? {
  header: _propTypes["default"].string.isRequired,
  open: _propTypes["default"].bool.isRequired,
  optionListRef: _propTypes["default"].func.isRequired,
  query: _propTypes["default"].string.isRequired,
  suggestions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].number,
    onClick: _propTypes["default"].func.isRequired,
    label: _propTypes["default"].string,
    render: _propTypes["default"].func
  })).isRequired,

  /**
   * See FocusTrap for details on how this works.
   */
  onBeforeBlur: _propTypes["default"].func.isRequired,
  onClickSuggestion: _propTypes["default"].func.isRequired,
  anchorNode: _propTypes["default"].object,
  footer: _propTypes["default"].node,
  maxHeight: _propTypes["default"].number,

  /**
   * A message to show in the popover when no suggestions are present.
   */
  message: _propTypes["default"].node,
  popoverId: _propTypes["default"].string,
  onChangePreselectedIndex: _propTypes["default"].func
} : {};
var _default = SearchSuggestionPopover;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian/search-field/search-suggestion-popover.js
// module id = 943
// module chunks = 0